import React from "react";
import { useAppDispatch, useAppSelector } from "store/store";
import { searchSelector, activeFilters, activeMobFilters } from "features/search-property/searchproperty.slice";
import useWindowSize from "hooks/useWindowSize";
import { clearSearchResult } from "features/search-result/searchresult.slice";

const Discounts: React.FC = () => {
  const dispatch = useAppDispatch();
  const size = useWindowSize();
  const { filters, mobFilters } = useAppSelector(searchSelector);
  const updateRating = (e: any) => {
    Array.from(document.querySelectorAll('.radio-label')).forEach((el) => el.classList.remove('radio_d_label_is_checked'));
    if (e.target.classList.contains('radio-label')) {
      const discount = e.target.dataset.discount;
      if (size.width ? size.width > 1110 : false) {
        let params = { ...filters };
        params['discount'] = discount;
        dispatch(clearSearchResult());
        dispatch(activeFilters(params));
      }
      else {
        e.target.classList.add('radio_d_label_is_checked');
        let params = { ...mobFilters };
        params['discount'] = discount;
        dispatch(activeMobFilters(params));
      }
    }
  }
  return (
    <>
      {/* <div> */}
      <div className="radio">
        <input id="radio-d1" name="radio-discount" type="radio" />
        <label htmlFor="radio-d1" className="radio-label" data-discount="10-30" onClick={(e) => { updateRating(e) }}>
          10%-30%
        </label>
      </div>
      <div className="radio">
        <input id="radio-d2" name="radio-discount" type="radio" />
        <label htmlFor="radio-d2" className="radio-label" data-discount="30-50" onClick={(e) => { updateRating(e) }}>
          30%-50%
        </label>
      </div>
      <div className="radio">
        <input id="radio-d3" name="radio-discount" type="radio" />
        <label htmlFor="radio-d3" className="radio-label" data-discount="50-70" onClick={(e) => { updateRating(e) }}>
          50%-70%
        </label>
      </div>
      {/* </div> */}
    </>
  );
};

export default Discounts;
